import { WHOLESALE_MIN_TOTAL_QTY } from '../utils/shopOrderType';

const ShopWholesaleMinQtyCallout = ({ t, current, showProgress = false, className = '' }) => {
  const minQty = WHOLESALE_MIN_TOTAL_QTY;
  const useProgress =
    showProgress &&
    typeof current === 'number' &&
    current > 0 &&
    current < minQty;

  const message = useProgress
    ? t('cart.wholesaleProgress', { current, count: minQty })
    : t('wholesaleBasket.minQtyCallout');

  return (
    <p
      role="status"
      className={`rounded-xl border border-violet-200 bg-violet-50 px-4 py-3 text-sm font-semibold text-violet-900 ${className}`.trim()}
    >
      {message}
    </p>
  );
};

export default ShopWholesaleMinQtyCallout;
